import store from "@/store/auth";
import Auth from "@/store/auth";

let Keywords = function() {
  this.getList = function() {
    return new Promise(resolve => {
      let url = process.env.VUE_APP_API + "keywords/";

      fetch(url, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + store.getters.getJwt
        }
      }).then(response => {
        if (response.status === 200) {
          response.json().then(json => {
            resolve(json);
          });
        } else if (response.status === 401) {
          Auth.dispatch("setJwt", "").catch(err => {
            console.error(err);
            resolve(false);
          });
          resolve([]);
        }
      });
    });
  };

  this.addKeyword = function(keyword) {
    return new Promise(resolve => {
      let url = process.env.VUE_APP_API + "keywords/";

      let data = {
        keyword: keyword
      };

      fetch(url, {
        method: "PUT",
        body: JSON.stringify(data),
        headers: {
          Authorization: "Bearer " + store.getters.getJwt
        }
      }).then(response => {
        if (response.status === 200) {
          response.json().then(json => {
            resolve(json.keywordId);
          });
        } else if (response.status === 401) {
          Auth.dispatch("setJwt", "").catch(err => {
            console.error(err);
            resolve(false);
          });
          resolve(false);
        }
      });
    });
  };

  this.updateKeyword = function(keywordId, keyword) {
    return new Promise(resolve => {
      let url = process.env.VUE_APP_API + "keywords/" + keywordId + "/";

      let data = {
        keyword: keyword
      };

      fetch(url, {
        method: "PUT",
        body: JSON.stringify(data),
        headers: {
          Authorization: "Bearer " + store.getters.getJwt
        }
      }).then(response => {
        if (response.status === 200) {
          response.json().then(json => {
            resolve(json.updated);
          });
        } else if (response.status === 401) {
          Auth.dispatch("setJwt", "").catch(err => {
            console.error(err);
            resolve(false);
          });
          resolve(false);
        }
      });
    });
  };
  this.removeKeyword = function(keywordId) {
    return new Promise(resolve => {
      let url = process.env.VUE_APP_API + "keywords/" + keywordId + "/";

      fetch(url, {
        method: "DELETE",
        headers: {
          Authorization: "Bearer " + store.getters.getJwt
        }
      }).then(response => {
        if (response.status === 200) {
          response.json().then(json => {
            resolve(json.deleted);
          });
        } else if (response.status === 401) {
          Auth.dispatch("setJwt", "").catch(err => {
            console.error(err);
            resolve(false);
          });
          resolve(false);
        }
      });
    });
  };
};

export default new Keywords();
